import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Execution from '../../images/settings.png';
import Waiting from '../../images/wait.png';
import Planning from '../../images/writing.png';
import Confirm from '../../images/confirm.png';
import Verified from '../../images/verified.png';
import Cancelled from '../../images/prohibition.png';
import getData from './../../data-services/api';
import Loader from '../../components/CustomLoader';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const styles = (theme) => ({});

class WorkshopList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            WorkshopList: [],
            loading: true,
        };
    }

    async componentDidMount() {
        //---------------- Save data if page refresh -------------------------------
        if (this.props.location.count === 0) {
            this.props.location.count = 1;
            localStorage.setItem(
                'Udata',
                JSON.stringify(this.props.location ? this.props.location : null)
            );
        }
        const userData = JSON.parse(localStorage.getItem('Udata'));

        var SFID = this.props.location.SFID ? this.props.location.SFID : userData.SFID;
        var userType = this.props.location.Type ? this.props.location.Type : userData.Type;

        const FCPUserQuery = `select * from salesforce.Opportunity where
            ((EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) AND EXTRACT(MONTH FROM start_date_time__c) >= 4) 
            OR (EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) + 1 AND EXTRACT(MONTH FROM start_date_time__c) <= 3))
            and AccountId ='${SFID}' and sfid is not null`;
        const CMDIUserQuery = `select * from Salesforce.Opportunity where
            ((EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) AND EXTRACT(MONTH FROM start_date_time__c) >= 4) 
            OR (EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) + 1 AND EXTRACT(MONTH FROM start_date_time__c) <= 3))
            and Assigned_CMDI__c = '${SFID}' and sfid is not null`;
        const AMMDUserQuery = `select * from Salesforce.Opportunity where
            ((EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) AND EXTRACT(MONTH FROM start_date_time__c) >= 4) 
            OR (EXTRACT(YEAR FROM start_date_time__c) = EXTRACT(YEAR FROM CURRENT_DATE) + 1 AND EXTRACT(MONTH FROM start_date_time__c) <= 3))
            and assigned_ammd__c = '${SFID}' and sfid is not null`;

        if (userType === 'AMMD') {
            Promise.all([getData(AMMDUserQuery)]).then(async ([AMMDUserData, ...data]) => {
                this.setState({
                    WorkshopList: AMMDUserData.result,
                    loading: false,
                });
            });
        } else if (userType === 'CMDI') {
            Promise.all([getData(CMDIUserQuery)]).then(async ([CMDIUserData, ...data]) => {
                this.setState({
                    WorkshopList: CMDIUserData.result,
                    loading: false,
                });
            });
        } else {
            Promise.all([getData(FCPUserQuery)]).then(async ([FCPUserData, ...data]) => {
                this.setState({
                    WorkshopList: FCPUserData.result,
                    loading: false,
                });
            });
        }
    }

    gotoWorkshop = (item) => {
        this.props.history.push({
            pathname: '/WorkshopDetails',
            heroku_id__c: item.heroku_id__c,
            sfid: item.sfid,
            id: this.props.location.SFID,
            stagename: item.stagename,
            Type: this.props.location.Type,
            count: 1,
            search: `?id=${this.props.location.SFID}&workshopSFID=${
                item.sfid
            }&source=lists&stagename=${item.stagename}&heroku_id__c=${item.heroku_id__c}`,
        });
    };

    goBackPrev = () => {
        this.props.history.push({
            pathname: '/super',
        });
    };

    render() {
        const { WorkshopList, loading } = this.state;

        let list = WorkshopList;
        list =
            list && list.length > 0
                ? list
                      .slice()
                      .sort((a, b) => new Date(b.end_date_time__c) - new Date(a.end_date_time__c))
                : [];

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    this.goBackPrev();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography variant="title" color="inherit" className="text-center">
                                Workshop List
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : list.length === 0 ? (
                    <Grid
                        container
                        alignItems="center"
                        justify="center"
                        style={{ marginTop: '20px' }}
                    >
                        <Typography variant="h6" color="textSecondary">
                            No data available
                        </Typography>
                    </Grid>
                ) : (
                    <>
                        <Fragment>
                            <List>
                                {list.map((item) => {
                                    return (
                                        <Paper key={item.id}>
                                            <Grid
                                                container
                                                spacing={8}
                                                alignItems="center"
                                                justify="space-between"
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    style={{ padding: 15 }}
                                                    onClick={() => this.gotoWorkshop(item)}
                                                >
                                                    <Typography
                                                        align="left"
                                                        variant="body2"
                                                        component=""
                                                        style={{ fontSize: 12 }}
                                                    >
                                                        {item.name}
                                                    </Typography>
                                                    <Typography
                                                        align="left"
                                                        variant="caption"
                                                        component="p"
                                                    >
                                                        {item.end_date_time__c}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography
                                                        align="right"
                                                        style={{
                                                            paddingRight: 10,
                                                        }}
                                                        zeroMinWidth
                                                    >
                                                        <div className="d-flex justify-content-end">
                                                            <div className="align-self-center">
                                                                {item.stagename}
                                                            </div>
                                                            <div className="align-self-center">
                                                                {item.stagename === 'Planning' && (
                                                                    <img
                                                                        src={Planning}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename ===
                                                                    'Awaiting Workshop Confirmation' && (
                                                                    <img
                                                                        src={Waiting}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename ===
                                                                    'Awaiting AMMD Approval' && (
                                                                    <img
                                                                        src={Waiting}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename ===
                                                                    'AMMD Confirmation' && (
                                                                    <img
                                                                        src={Confirm}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename === 'Execution' && (
                                                                    <img
                                                                        src={Execution}
                                                                        style={{
                                                                            width: '35px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename ===
                                                                    'CMDI Verification' && (
                                                                    <img
                                                                        src={Verified}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename === 'Paid' && (
                                                                    <img
                                                                        src={Confirm}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename === 'Cancelled' && (
                                                                    <img
                                                                        src={Cancelled}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                                {item.stagename ===
                                                                    'Account Approved' && (
                                                                    <img
                                                                        src={Confirm}
                                                                        style={{
                                                                            width: '30px',
                                                                            paddingLeft: '10px',
                                                                        }}
                                                                        alt="img"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Divider />
                                        </Paper>
                                    );
                                })}
                            </List>
                        </Fragment>
                    </>
                )}
            </>
        );
    }
}

WorkshopList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(WorkshopList));
